// extracted by mini-css-extract-plugin
export default {"side-slider":"UtCzZhh0yTROmrdmbVCcrQ==","open":"twV27CxPMEPc3w+LSVOP6w=="};